import { useMemo } from "react";
import useAllCountries from "@hooks/countries/use-all-countries";

const emptyArr = [];

const useSelectedCountriesIsos = ({ currentCountryIds }) => {
  const { allCountriesList } = useAllCountries({
    includeGlobalCountry: true,
    showGlobalCountryAtTop: true,
  });

  const selectedCountryIsos = useMemo(() => {
    if (!currentCountryIds?.length) return emptyArr;
    return allCountriesList
      .filter((c) => currentCountryIds.includes(String(c.id)))
      .map((c) => c.iso?.toLowerCase())
      .filter(Boolean);
  }, [currentCountryIds, allCountriesList]);

  return useMemo(() => ({ selectedCountryIsos }), [selectedCountryIsos]);
};

export default useSelectedCountriesIsos;
